export default __webpack_public_path__ + "media/images/mailer-new/welcome/checkbox-off-a5e6539984c687274e05dff5b56b84c3.png";